import styled from 'styled-components'

export const Wrapper = styled.div`
  background-image: url('banner.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;

  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  flex-direction: column;
`
export const Card = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10vh;
`
export const Login = styled.div`
  width: 100%;
  padding: 4vh;
  border-radius: 5px;
  max-width: 400px;
  background-color: #ccc;
  border: 1px solid var(--color-dark-grey);
  background-color: var(--color-light-grey);
  & form {
    display: flex;
    flex-direction: column;
  }
  & form button {
    margin-top: 8px;
  }
`
